"use strict";
// tslint:disable-next-line: max-line-length
/* tslint:disable no-fallthrough, no-underscore-dangle, no-bitwise, default-case, no-parameter-reassignment, no-var-requires */
Object.defineProperty(exports, "__esModule", { value: true });
exports.bucket = exports.hash = void 0;
const murmurhash_js_1 = require("murmurhash-js");
const utf8 = require("utf8");
function hash(str, seed) {
    // Ensure str is encoded to UTF8, and seed is a positive 32-bit integer
    // tslint:disable-next-line: max-line-length
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Unsigned_right_shift
    return murmurhash_js_1.murmur3(utf8.encode(str), seed >>> 0);
}
exports.hash = hash;
function bucket(str, seed = 1) {
    return Math.abs(hash(str, seed) % 100) + 1;
}
exports.bucket = bucket;
//# sourceMappingURL=murmurhash.js.map